/**
 * Gets first day of the month of a given date
 */
export default function getStartOfMonth(dt) {
  return new Date(dt.getFullYear(), dt.getMonth(), 1);
}
